<script setup lang="ts">
import AppError410 from '~/components/AppError410.vue'

const error = useError()

const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <NuxtLayout name="empty">
    <div class="flex min-h-screen w-full flex-col items-center justify-center">
      <AppError404 v-if="error?.statusCode === 404" />
      <AppError410 v-else-if="error?.statusCode === 410"/>

      <AppContainer v-else class="my-10 md:my-20">
        <div class="row mb-10 justify-center text-center md:mb-16">
          <div class="col-lg-6">
            <h1 class="h3">Oops, something went wrong.</h1>

            <p v-if="error?.message" class="mt-5">{{ error.message }}</p>
          </div>
        </div>

        <div class="row justify-center">
          <div class="col-sm-3">
            <AppButton full-width @click="handleError">Back to home</AppButton>
          </div>
        </div>
      </AppContainer>
    </div>
  </NuxtLayout>
</template>
